export default "__VITE_ASSET__DY3_dASh__"